import React, { useEffect, useState } from 'react';
import styles from './ModuleForm.module.css';
import { ReactComponent as Close } from '../ico/close.svg';
import { Button } from '../../UI/Button/Button';
import { Input } from '../../UI/input/input';
import { Checkbox } from '../../UI/Checkbox/Checkbox';
import { useApi } from '../../../hooks/useApi';
import { useStores } from '../../../hooks/useStore';
import { Lesson } from '../../../models/courses';

interface LessonFormProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  moduleId: string;
  lesson?: Lesson | null;
}

const LessonForm: React.FC<LessonFormProps> = ({
  open,
  onClose,
  onSuccess,
  moduleId,
  lesson,
}) => {
  const api = useApi();
  const store = useStores();

  const [title, setTitle] = useState<string>('');
  const [durationMinutes, setDurationMinutes] = useState<string>('');
  const [isPreview, setIsPreview] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);

  useEffect(() => {
    if (open) {
      setTitle(lesson?.title ?? '');
      setDurationMinutes(
        lesson?.duration_minutes ? String(lesson.duration_minutes) : '',
      );
      setIsPreview(lesson?.is_preview ?? false);
    }
  }, [open, lesson]);

  useEffect(() => {
    setDisabled(title.trim() === '');
  }, [title]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      store.notificationsStore.showPreloader();

      const durationParsed =
        durationMinutes !== '' ? parseInt(durationMinutes, 10) : undefined;

      if (lesson) {
        await api.courses.updateLesson(
          {
            title: title.trim(),
            duration_minutes: durationParsed,
            is_preview: isPreview,
          },
          lesson.id,
        );
      } else {
        await api.courses.createLesson(moduleId, {
          title: title.trim(),
          duration_minutes: durationParsed,
          is_preview: isPreview,
        });
      }

      store.notificationsStore.setNotifications('Успешно выполнено');
      onSuccess();
      onClose();
    } catch {
      store.notificationsStore.setError('Ошибка при выполнении');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  if (!open) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          <Close />
        </button>
        <h3>{lesson ? 'Редактировать урок' : 'Добавить урок'}</h3>
        <div className={styles.line} />
        <form onSubmit={handleSubmit}>
          <Input
            textLabel="Название"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            style={{ marginBottom: 16 }}
          />
          <Input
            textLabel="Длительность (мин)"
            type="number"
            min={0}
            value={durationMinutes}
            onChange={(e) => setDurationMinutes(e.target.value)}
            style={{ marginBottom: 16 }}
          />
          <Checkbox
            label="Доступен без подписки"
            checked={isPreview}
            onChange={(e) => setIsPreview(e.target.checked)}
            style={{ marginBottom: 24 }}
          />
          <Button type="submit" appearance="auth" disabled={disabled}>
            {lesson ? 'Сохранить' : 'Создать'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default LessonForm;
